export { default as UploadOutlineIcon } from './UploadOutlineIcon';
